import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import ProgressiveImage from 'react-progressive-image';
import blur from '../../assets/blur.jpg';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import './MainSwiper.scss';

class MainSwiper extends Component {
  render() {
    const params = {
      lazy: true,
      rebuildOnUpdate: true,
      slidesPerView: 7,
      spaceBetween: 10,
      slidesPerGroup: 2,
      loopFillGroupWithBlank: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        1145: {
          slidesPerView: 5
        },
        850: {
          slidesPerView: 4
        },
        640: {
          slidesPerView: 3
        },
        475: {
          slidesPerView: 2
        }
      }
    };

    let genres = this.props.sources.map(el =>
      el.genres.map(genre => this.props.genres[genre])
    );

    let slides = this.props.sources.map((el, i) => {
      return (
        <div className="backdrop_container" key={el.id}>
          <Link
            className="title-link"
            to={`/${this.props.type.toLowerCase()}/${el.id}`}>
            <ProgressiveImage src={el.imgSrc} placeholder={blur}>
              {(src, loading) => (
                <img
                  style={{
                    opacity: loading ? 0.5 : 1,
                    filter: loading ? 'blur(5px)' : '',
                    width: loading ? 'auto' : 'auto',
                    height: loading ? '190px' : '190px',
                    borderRadius: loading ? '5px' : '5px',
                    transition: 'opacity 1s ease'
                  }}
                  src={src}
                  alt={el.title}
                />
              )}
            </ProgressiveImage>
          </Link>
          <h3 className="backdrop_container__title">{el.title}</h3>
          <p className="backdrop_container__genre">
            {genres[i].filter(el => el).length >= 1
              ? genres[i]
                .filter(el => el)
                .slice(0, 2)
                .join(' / ')
              : ''}
          </p>
          <p className="backdrop_container__rating">
            <svg
              className="backdrop_container__rating-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512">
              <path d="M256 372.686L380.83 448l-33.021-142.066L458 210.409l-145.267-12.475L256 64l-56.743 133.934L54 210.409l110.192 95.525L131.161 448z" />
            </svg>
            {el.rating}
          </p>
        </div>
      );
    });

    return (
      <>
        <h3 className="slider__title">{this.props.title}</h3>
        <Swiper {...params}>{slides}</Swiper>
        <hr className="swiper-divider" />
      </>
    );
  }
}

export default withRouter(MainSwiper);
